export const FETCH_EMP_ALLOCATION_REQUEST = "FETCH_EMP_ALLOCATION_REQUEST";
export const FETCH_EMP_ALLOCATION_SUCCESS = "FETCH_EMP_ALLOCATION_SUCCESS";
export const FETCH_EMP_ALLOCATION_FAILURE = "FETCH_EMP_ALLOCATION_FAILURE";